module.exports = __webpack_public_path__ + "img/step_3.e5243d48.svg";